module.exports = __webpack_public_path__ + "img/magentoicon.ebc90712.svg";